import { useState, useEffect } from 'react';
import AppLogo from '../../assets/SiteMasterLoading.png';

export default function LoadingScreen({ loading, children }) {

  return (
    <div className="relative ">
      <div className={`transition-opacity duration-500 ${loading ? 'opacity-0' : 'opacity-100'}`}>
        {children}
      </div>

      {loading && (
        <div className="fixed ml-40 inset-0 flex items-center justify-center z-50">
          <div className="relative w-40 h-40 flex items-center justify-center">
            <svg
              className="absolute inset-0 rotate-ring"
              viewBox="0 0 160 160"
              style={{ width: '160px', height: '160px' }}
            >
              <defs>
                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.8" />
                  <stop offset="50%" stopColor="#3B0069" stopOpacity="1" />
                  <stop offset="100%" stopColor="#6366F1" stopOpacity="0.6" />
                </linearGradient>
              </defs>
              <circle
                cx="80"
                cy="80"
                r="70"
                fill="none"
                stroke="url(#gradient1)"
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray="20 10"
              />
            </svg>

            <svg
              className="absolute pulse-circle"
              viewBox="0 0 128 128"
            >
              <circle
                cx="64"
                cy="64"
                r="56"
                fill="none"
                stroke="#3B0069"
                strokeWidth="2"
                strokeLinecap="round"
                opacity="0.4"
              />
            </svg>

            <svg
              className="absolute"
              viewBox="0 0 128 128"
            >
              <circle
                cx="64"
                cy="64"
                r="56"
                fill="none"
                stroke="#3B0069"
                strokeWidth="3"
                strokeLinecap="round"
                className="stroke-draw"
              />
            </svg>

            <img
              src={AppLogo}
              alt="Loading"
              className="relative w-24 h-24 object-contain logo-fade-in z-10"
            />

            {/* <div className="absolute inset-0 shimmer-overlay" /> */}
          </div>

          <div className="absolute bottom-1/3 text-center loading-text">
            <p className="text-purple-900 font-semibold text-lg">Loading...</p>
          </div>
        </div>
      )}

      <style>
        {`
          .stroke-draw {
            stroke-dasharray: 352;
            stroke-dashoffset: 352;
            animation: drawStroke 1.3s ease-in-out forwards;
          }

          .logo-fade-in {
            opacity: 0;
            transform: scale(0.85);
            animation: logoReveal 1.3s ease-in-out forwards;
          }

          .rotate-ring {
            animation: rotateRing 1.5s linear infinite;
          }

          .pulse-circle {
            animation: pulse 1.3s ease-in-out infinite;
          }

          .glow-pulse {
            animation: glowPulse 1.3s ease-in-out infinite;
          }

          .shimmer-overlay {
            background: linear-gradient(
              90deg,
              transparent 0%,
              rgba(255, 255, 255, 0.6) 50%,
              transparent 100%
            );
            animation: shimmer 1.3s ease-in-out infinite;
            pointer-events: none;
          }

          .loading-text {
            animation: textFade 1.3s ease-in-out infinite;
          }

          @keyframes drawStroke {
            0% {
              stroke-dashoffset: 352;
              opacity: 1;
            }
            70% {
              stroke-dashoffset: 0;
              opacity: 1;
            }
            85% {
              stroke-dashoffset: 0;
              opacity: 0.5;
            }
            100% {
              stroke-dashoffset: 0;
              opacity: 0;
            }
          }

          @keyframes logoReveal {
            0% {
              opacity: 0;
              transform: scale(0.85);
            }
            40% {
              opacity: 0;
            }
            70% {
              opacity: 1;
              transform: scale(1.05);
            }
            85% {
              transform: scale(0.98);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes rotateRing {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.4;
            }
            50% {
              transform: scale(1.08);
              opacity: 0.2;
            }
          }

          @keyframes shimmer {
            0% {
              transform: translateX(-100%) rotate(45deg);
            }
            100% {
              transform: translateX(200%) rotate(45deg);
            }
          }

          @keyframes textFade {
            0%, 100% {
              opacity: 0.6;
            }
            50% {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}